import TipsCard from "../Card/TipsCard";
import Container from "~/components/atoms/Container";
import { Link } from "@remix-run/react";
import { getRegionUrlPrefix } from "~/lib/helpers/slugHelper";
import { OhButton } from "~/components/ui/custom-radix-components/button";
import { HOME_PAGE_SECTION_IDS } from "./constants";

export const GuideAndTips = ({ blogs, region }: { blogs: any[], region: string }) => {

  // Safety check for blogs data
  if (!blogs || !Array.isArray(blogs) || blogs.length === 0) {
    return (
      <Container htmlFor="ultra-wide">
        <div id={HOME_PAGE_SECTION_IDS.guidesAndTips} className="relative w-full bg-center bg-cover scroll-mt-28">
          <div className='relative'>
            <h2 className='text-center text-oh-black text-3xl font-bold mb-4'>
              Explore Workspace Tips and Insights
            </h2>
            <p className='text-center font-semibold text-gray-500 text-xl mb-8'>
              Discover expert guides, office trends, and workspace ideas to help your business grow smarter.
            </p>
            <div className="text-center text-gray-500">
              No blogs available at the moment.
            </div>
          </div>
        </div>
      </Container>
    );
  }

  return (
    <Container htmlFor="ultra-wide" >
      <div id={HOME_PAGE_SECTION_IDS.guidesAndTips} className="relative w-full bg-center bg-cover scroll-mt-28">
        <div className='relative '>
          <h2 className='text-center text-oh-black text-3xl font-bold mb-2'>
            {/* Help Guide & Tips */}
            Explore Workspace Tips and Insights
          </h2>
          <p className='text-center font-semibold text-gray-500 text-xl mb-6'>
            Discover expert guides, office trends, and workspace ideas to help your business grow smarter.
          </p>
          <div className='grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-3 place-items-center'>
            {/* First Column - Full Height Card */}
            {blogs[0] && (
              <TipsCard
                tipAndGuide={blogs[0]}
                className='h-[320px] md:h-[530px] w-full'
                region={region}
              />
            )}
            {/* Second Column - Two Half Height Cards */}
            <div className='flex flex-col gap-4 w-full'>
              {blogs[1] && (
                <TipsCard
                  tipAndGuide={blogs[1]}
                  className='h-[151px] md:h-[257px] w-full'
                  region={region}
                />
              )}
              {blogs[2] && (
                <TipsCard
                  tipAndGuide={blogs[2]}
                  className='h-[151px] md:h-[257px] w-full'
                  region={region}
                />
              )}
            </div>
            {blogs[3] && (
              <TipsCard
                tipAndGuide={blogs[3]}
                className='hidden md:block h-[530px] w-full'
                region={region}
              />
            )}
            <div className='hidden md:flex flex-col gap-4 w-full'>
              {blogs[4] && (
                <TipsCard
                  tipAndGuide={blogs[4]}
                  className='h-[257px] w-full'
                  region={region}
                />
              )}
              {blogs[5] && (
                <TipsCard
                  tipAndGuide={blogs[5]}
                  className='h-[257px] w-full'
                  region={region}
                />
              )}
            </div>
          </div>

          <div className='flex justify-center mt-8 md:mt-12'>
            <Link to={`${getRegionUrlPrefix(region)}/blog`} target="_blank" prefetch="intent" className="w-full md:w-auto">
              <OhButton
                className='px-4 md:px-16 w-full'
              >
                {/* More Tips And Guide */}
                View More
              </OhButton>
            </Link>
          </div>
        </div>
      </div>
    </Container>
  );
};
